import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMotoristaUser, logoutMotorista, fetchMotoristaApi } from '../../services/motoristaAuth';

const MotoristaDashboard: React.FC = () => {
  const navigate = useNavigate();
  const motorista = getMotoristaUser();
  const [checklists, setChecklists] = useState<any[]>([]);
  const [veiculos, setVeiculos] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [checkRes, veicRes] = await Promise.allSettled([
        fetchMotoristaApi('/checklists?limit=5'),
        fetchMotoristaApi('/veiculos')
      ]);

      if (checkRes.status === 'fulfilled' && checkRes.value.success) {
        setChecklists(checkRes.value.data?.checklists || []);
      }
      if (veicRes.status === 'fulfilled' && veicRes.value.success) {
        setVeiculos(veicRes.value.data || []);
      }
    } catch (err) {
      console.error('Erro ao carregar dados:', err);
    } finally { setIsLoading(false); }
  };

  const handleLogout = () => {
    logoutMotorista();
    navigate('/motorista/login', { replace: true });
  };

  const formatDate = (d: string) => d ? new Date(d).toLocaleDateString('pt-BR') : '-';

  const cnhVencida = motorista?.cnh_vencimento && new Date(motorista.cnh_vencimento) < new Date();
  const cnhDias = motorista?.cnh_vencimento
    ? Math.ceil((new Date(motorista.cnh_vencimento).getTime() - Date.now()) / (1000 * 60 * 60 * 24))
    : null;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f6fa' }}>
      {/* Header */}
      <div style={{ background: '#04C64F', color: 'white', padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.2rem' }}>Ola, {motorista?.nome?.split(' ')[0] || 'Motorista'}</h1>
          <p style={{ margin: 0, fontSize: '0.8rem', opacity: 0.9 }}>{motorista?.empresa_nome}</p>
        </div>
        <button onClick={handleLogout} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>
          <i className="fas fa-sign-out-alt"></i> Sair
        </button>
      </div>

      <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
        {/* Alerta de CNH */}
        {cnhVencida && (
          <div style={{ background: '#fce4ec', color: '#c62828', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
            <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
            <strong>CNH VENCIDA!</strong> Vencimento: {formatDate(motorista.cnh_vencimento)}
          </div>
        )}
        {!cnhVencida && cnhDias !== null && cnhDias <= 30 && (
          <div style={{ background: '#fff3e0', color: '#e65100', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
            <i className="fas fa-clock" style={{ marginRight: '8px' }}></i>
            CNH vence em <strong>{cnhDias} dias</strong> ({formatDate(motorista.cnh_vencimento)})
          </div>
        )}

        {/* Acoes rapidas */}
        <h2 style={{ fontSize: '1.1rem', color: '#2c3e50', marginBottom: '15px' }}>Acoes Rapidas</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '25px' }}>
          <button
            onClick={() => navigate('/motorista/checklist')}
            style={{ background: 'white', border: '2px solid #04C64F', borderRadius: '12px', padding: '20px', cursor: 'pointer', textAlign: 'center' }}
          >
            <i className="fas fa-clipboard-check" style={{ fontSize: '28px', color: '#04C64F', display: 'block', marginBottom: '8px' }}></i>
            <span style={{ fontWeight: '600', color: '#2c3e50', fontSize: '0.9rem' }}>Novo Checklist</span>
          </button>
          <button
            onClick={() => navigate('/motorista/historico')}
            style={{ background: 'white', border: '2px solid #04C64F', borderRadius: '12px', padding: '20px', cursor: 'pointer', textAlign: 'center' }}
          >
            <i className="fas fa-history" style={{ fontSize: '28px', color: '#04C64F', display: 'block', marginBottom: '8px' }}></i>
            <span style={{ fontWeight: '600', color: '#2c3e50', fontSize: '0.9rem' }}>Historico</span>
          </button>
        </div>

        {/* Info do motorista */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '1rem', color: '#2c3e50', marginBottom: '12px' }}>Meus Dados</h3>
          <div style={{ fontSize: '0.9rem', color: '#7f8c8d' }}>
            <p><strong>CPF:</strong> {motorista?.cpf}</p>
            <p><strong>CNH:</strong> {motorista?.cnh_numero} ({motorista?.cnh_categoria})</p>
            <p><strong>Vencimento CNH:</strong> {formatDate(motorista?.cnh_vencimento)}</p>
          </div>
        </div>

        {/* Veiculos disponiveis */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '1rem', color: '#2c3e50', marginBottom: '12px' }}>Veiculos Disponiveis ({veiculos.length})</h3>
          {isLoading ? <p>Carregando...</p> : veiculos.length === 0 ? <p style={{ color: '#95a5a6' }}>Nenhum veiculo disponivel</p> : (
            <div style={{ maxHeight: '200px', overflow: 'auto' }}>
              {veiculos.map((v: any) => (
                <div key={v.id} style={{ padding: '10px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
                  <strong>{v.placa}</strong>
                  <span style={{ color: '#7f8c8d' }}>{v.marca} {v.modelo}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Ultimos checklists */}
        <div style={{ background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <h3 style={{ fontSize: '1rem', color: '#2c3e50', marginBottom: '12px' }}>Ultimos Checklists</h3>
          {isLoading ? <p>Carregando...</p> : checklists.length === 0 ? <p style={{ color: '#95a5a6' }}>Nenhum checklist realizado</p> : (
            <div>
              {checklists.map((c: any) => (
                <div key={c.id} style={{ padding: '10px', borderBottom: '1px solid #f0f0f0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong>{c.veiculo_placa || 'S/Veiculo'}</strong>
                    <span style={{ fontSize: '0.8rem', color: c.status === 'concluido' ? '#04C64F' : '#f39c12' }}>
                      {c.status === 'concluido' ? 'Concluido' : c.status}
                    </span>
                  </div>
                  <div style={{ fontSize: '0.8rem', color: '#95a5a6' }}>
                    {formatDate(c.data_realizacao)} - {c.tipo || 'Checklist'}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MotoristaDashboard;
